import { StyledFormContainer } from "./index.styled";
import React from "react";

export const FormContainer = (props) => {
  return (
    <StyledFormContainer align={props.align || "end"}>
      {props.children}
    </StyledFormContainer>
  );
};
